<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_40 col_20'><span class='brt high default' id='text1'>NATIONAL RAILROAD  PASSENGER CORPORATION</span>  </div>
  <div class='lgr_05 col_75'><span class='default' id='text2'>S142G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><dynamic-field [id]='"scrntm"' [size]=8 [line]=2 [column]=1 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_38 col_21'><span class='brt high default' id='text3'>ZONE PATH TABLE FLS01T03 INSERT SCREEN</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_40 col_20'><span class='brt high default' id='text4'>----------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_28 col_01'><span class='default' id='text5'>ENTER VALUES FOR ALL FIELDS:</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_28 col_01'><span class='default' id='text6'>----------------------------</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_14 col_01'><span class='default' id='text7'>FLASH TYPE CD:</span>  </div>
  <div class='lgr_01 col_20'><dynamic-field [id]='"typecd"' [size]=1 [line]=7 [column]=20 [(ngModel)]='typecd'></dynamic-field></div>
  <div class='lgr_00 col_22'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_13 col_01'><span class='default' id='text9'>FROM ZONE ID:</span>  </div>
  <div class='lgr_04 col_20'><dynamic-field [id]='"frznid"' [size]=4 [line]=9 [column]=20 [(ngModel)]='frznid'></dynamic-field></div>
  <div class='lgr_00 col_25'>  </div>
  <div class='lgr_11 col_35'><span class='default' id='text11'>TO ZONE ID:</span>  </div>
  <div class='lgr_04 col_55'><dynamic-field [id]='"toznid"' [size]=4 [line]=9 [column]=55 [(ngModel)]='toznid'></dynamic-field></div>
  <div class='lgr_00 col_60'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_13 col_01'><span class='default' id='text13'>FRST TRN NBR:</span>  </div>
  <div class='lgr_04 col_20'><dynamic-field [id]='"ftrnno"' [size]=4 [line]=11 [column]=20 [(ngModel)]='ftrnno'></dynamic-field></div>
  <div class='lgr_00 col_25'>  </div>
  <div class='lgr_19 col_35'><span class='default' id='text15'>FRST TRNSF LOCN CD:</span>  </div>
  <div class='lgr_03 col_55'><dynamic-field [id]='"floccd"' [size]=3 [line]=11 [column]=55 [(ngModel)]='floccd'></dynamic-field></div>
  <div class='lgr_00 col_59'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_13 col_01'><span class='default' id='text17'>SCND TRN NBR:</span>  </div>
  <div class='lgr_04 col_20'><dynamic-field [id]='"strnno"' [size]=4 [line]=13 [column]=20 [(ngModel)]='strnno'></dynamic-field></div>
  <div class='lgr_00 col_25'>  </div>
  <div class='lgr_19 col_35'><span class='default' id='text19'>SCND TRNSF LOCN CD:</span>  </div>
  <div class='lgr_03 col_55'><dynamic-field [id]='"sloccd"' [size]=3 [line]=13 [column]=55 [(ngModel)]='sloccd'></dynamic-field></div>
  <div class='lgr_00 col_59'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_14 col_01'><span class='default' id='text21'>THRD TRN NBR: </span>  </div>
  <div class='lgr_04 col_20'><dynamic-field [id]='"ttrnno"' [size]=4 [line]=15 [column]=20 [(ngModel)]='ttrnno'></dynamic-field></div>
  <div class='lgr_00 col_25'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_13 col_01'><span class='default' id='text23'>EFFECTIVE DT:</span>  </div>
  <div class='lgr_10 col_20'><dynamic-field [id]='"eftvdt"' [size]=10 [line]=17 [column]=20 [(ngModel)]='eftvdt'></dynamic-field></div>
  <div class='lgr_00 col_31'>  </div>
  <div class='lgr_14 col_35'><span class='default' id='text25'>EXPIRATION DT:</span>  </div>
  <div class='lgr_10 col_55'><dynamic-field [id]='"exprdt"' [size]=10 [line]=17 [column]=55 [(ngModel)]='exprdt'></dynamic-field></div>
  <div class='lgr_00 col_66'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_15 col_01'><span class='default' id='text27'>ALLOCATION PCT:</span>  </div>
  <div class='lgr_05 col_20'><dynamic-field [id]='"alcpct"' [size]=5 [line]=19 [column]=20 [(ngModel)]='alcpct'></dynamic-field></div>
  <div class='lgr_00 col_26'>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_40 col_01'><span class='default' id='text29'>(In 999v99 format with no decimal point)</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=23 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><span class='brt high default' id='text30'>PF3=EXIT</span>  </div>
  <div class='lgr_10 col_12'><span class='brt high default' id='text31'>PF4=RETURN</span>  </div>
  <div class='lgr_12 col_25'><span class='brt high default' id='text32'>ENTER=SELECT</span>  </div>
  <div class='lgr_10 col_40'><span class='brt high default' id='text33'>PF5=INSERT</span>  </div>
  <div class='lgr_10 col_53'><span class='brt high default' id='text34'>PF6=UPDATE</span>  </div>
  <div class='lgr_10 col_66'><span class='brt high default' id='text35'>PF9=DELETE</span>  </div>
</div>
</div>
